import { openBlock, createElementBlock, createStaticVNode } from "vue";
import _export_sfc from "../uikit._virtual/_plugin-vue_export-helper.es.js";
const _sfc_main = {
  name: "uikit-streetview-icon"
};
const _hoisted_1 = {
  width: "17",
  height: "16",
  viewBox: "0 0 17 16",
  fill: "currentColor",
  stroke: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createStaticVNode('<g clip-path="url(#clip0_3154_589)"><path opacity="0.4" d="M8.77783 4C9.8833 4 10.7778 3.10547 10.7778 2C10.7778 0.894531 9.8833 0 8.77783 0C7.67236 0 6.77783 0.894531 6.77783 2C6.77783 3.10547 7.67236 4 8.77783 4ZM12.2778 10.7479V12.1763C13.9021 12.3516 15.2778 12.678 15.2778 13.25C15.2778 14.2368 11.192 14.5 8.77783 14.5C6.36377 14.5 2.27783 14.2368 2.27783 13.25C2.27783 12.6342 3.86177 12.3257 5.27783 12.1722V10.7407C3.39821 11.0151 0.777832 11.6798 0.777832 13.25C0.777832 15.4209 5.80664 16 8.77783 16C11.749 16 16.7778 15.4209 16.7778 13.25C16.7778 11.8242 14.6086 11.087 12.2778 10.7479Z"></path><path d="M6.77783 9.5L7.16833 12.624C7.23089 13.1245 7.6563 13.5 8.16061 13.5H9.39505C9.89936 13.5 10.3248 13.1245 10.3873 12.624L10.7778 9.5C11.3301 9.5 11.7778 9.05225 11.7778 8.5V7C11.7778 5.89544 10.8824 5 9.77783 5H7.77783C6.67327 5 5.77783 5.89544 5.77783 7V8.5C5.77783 9.05225 6.22552 9.5 6.77783 9.5Z"></path></g><defs><clipPath id="clip0_3154_589"><rect width="16" height="16" fill="white" transform="translate(0.777832)"></rect></clipPath></defs>', 2);
const _hoisted_4 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
const uikitStreetviewIcon = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  uikitStreetviewIcon as default
};
//# sourceMappingURL=uikit-streetview-icon.vue.es.js.map
